// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3bgAP","head":"ProcedureTableInfo_head__20oSx"};